import Cookies from 'js-cookie'
import each from 'lodash/each'
import xor from 'lodash/xor'
import Vue from 'vue'
import eventBus from '../../eventBus'
import AddToComparisonWidget from './AddToComparisonWidget'
import OverviewWidget from './OverviewWidget'
import store, { COOKIE_ID, getProductIdsFromCookie, MAX_PRODUCTS } from './store'

store.watch(
  (state) => state.productIds,
  (productIds) => {
    if (productIds.length > MAX_PRODUCTS) {
      const removed = productIds.splice(0, productIds.length - MAX_PRODUCTS)
      removed.forEach((id) => {
        eventBus.$emit('remove-product-from-comparison', id)
      })
    }

    Cookies.set(COOKIE_ID, productIds.join(','), { expires: 90 })
  },
)

setInterval(() => {
  const newIds = getProductIdsFromCookie()
  if (xor(newIds, store.state.productIds).length) {
    store.commit('setProductIds', newIds)
    eventBus.$emit('product-comparison-cookie-changed-externally')
  }
}, 500)

eventBus.$on('add-product-to-comparison', (product) => {
  store.commit('addProduct', product)
})

eventBus.$on('remove-product-from-comparison', (id) => {
  store.commit('removeProduct', id)
})

eventBus.$on('product-comparison-cookie-changed-externally', () => {
  store.dispatch('loadProductInfo').then(() => {})
})

const overviewWidget = document.querySelector('.js-product-comparison-overview-widget')
if (overviewWidget) {
  new Vue({
    name: 'ProductComparisonOverviewWidget_Vue',
    el: overviewWidget,
    components: {
      ProductComparisonOverviewWidget: OverviewWidget,
    },
    template: '<ProductComparisonOverviewWidget />',
  })

  store.dispatch('loadProductInfo').then(() => {})
}

function setupAddToComparisonWidgets(container) {
  const widgets = container.querySelectorAll('.js-add-to-comparison-widget')
  if (widgets.length) {
    widgets.forEach((el) => {
      new Vue({
        name: 'AddToComparisonWidget_Vue',
        el,
        store,
        components: {
          AddToComparisonWidget,
        },
      })
    })
  }
}

function watchForAddToComparisonWidgets(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  setupAddToComparisonWidgets(container)

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        setupAddToComparisonWidgets(node)
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

watchForAddToComparisonWidgets(document)
